import {Roles} from "../../Enums"
import {PolicyConstants} from "../constants/PolicyConstants";
import {PermissionConstants} from "../constants/PermissionConstants";

export class SystemUserAdministratePolicies {

    public static Name = PolicyConstants.SYSTEM_ADMINISTRATION_POLICIES;
    public static PermissionSets = [PermissionConstants.READ, PermissionConstants.EDIT, PermissionConstants.MANAGE_CERTIFICATES];

    private static _readRestrictions: Roles[] =
        [
            Roles.Administrator,
            Roles.Hauptbenutzer,
        ];

    private static _editRestrictions =
        [
            Roles.Administrator,
        ];

    private static _certificateRestrictions =
        [
            Roles.Administrator,
            Roles.Hauptbenutzer
        ]

    public static GetPermissions() {
        return new Map([
            [PermissionConstants.READ, this._readRestrictions],
            [PermissionConstants.EDIT, this._editRestrictions],
            [PermissionConstants.MANAGE_CERTIFICATES, this._certificateRestrictions]
        ])
    }

}